<template>
  <div class="body">
    <div id="game"></div> 
    <h1 class="score">分数：{{ score }}</h1>
    <van-popup v-model="showStart" :style="{ height: '100%', width: '100%' }">
      <div class="panel">
        <h1 class="logo">是男人<br />就下100层</h1>
        <br /><br /><br />
        <ul>
          <li>{{ price }} 金豆游戏一次</li>
          <li>点击屏幕,左右移动色块, 相同颜色,可消除一层</li>
          <li>消除一层 分数 +{{ gameConf.coinAdd }}</li>
          <li>色块触碰顶端, 游戏结束</li>
          <li>结束后, 所有分数结算为金豆</li>
        </ul>
        <br />
        <van-button
          type="danger"
          plain
          @click="gameStart()"
          :loading="progress < 1"
          :loading-text="parseInt(progress * 100) + ' %'"
          :disabled ="play_times_today>=play_times_max"
        >
          开始游戏 {{play_times_today}}/{{play_times_max}}
        </van-button>
        <br /><br />
        <van-button type="info" plain @click="quit()"> 退出 </van-button>
      </div>
    </van-popup>
    <van-popup v-model="showEndTip" :style="{ height: '100%', width: '100%' }">
      <div class="panel">
        <br /><br /><br />
        <h1 class="logo">游戏结束</h1>
        <br /><br /><br />
        <h2>结算中,请稍后...</h2>
      </div>
    </van-popup>
    <van-popup v-model="showEnd" :style="{ height: '100%', width: '100%' }">
      <div class="panel">
        <h1 class="logo">是男人<br />就下100层</h1>
        <br /><br /><br />
        <div class="endInfo">
          <br /><br />
          <h2>获得金豆: {{ score }}</h2>
        </div>

        <br />
        <h1>当前金豆: {{ user_score }}</h1>
        <br /><br />
        <van-button type="danger" plain @click="gameStart()"
        :disabled ="play_times_today>=play_times_max"
          >重新开始 {{play_times_today}}/{{play_times_max}}</van-button
        >
        <br /><br />
        <van-button
          type="primary"
          plain
          @click="
            showEnd = false;
            showStart = true;
          "
          >查看规则</van-button
        >
        <br /><br />
        <van-button type="info" plain @click="quit()">退出</van-button>
      </div>
    </van-popup>
  </div>
</template>
<style scoped>
.panel {
  padding: 2rem 0.5rem;
  /* background-color:white; */
  text-align: center;
}
.van-popup {
  background-color: #00000000;
  color: white;
}
.panel .logo {
  font-size: 0.8rem;
  color: tomato;
}
.score {
  font-size: 0.5rem;
  color: #ffffff;
  position: fixed;
  top: 0;
}
.body{
  background-color: #000000 !important;
  height: 100%;
}
</style>
<script>
import Vue from "vue";
import { Popup } from "vant";
import { Button } from "vant";
import { Col, Row } from "vant";
import { Toast } from "vant";

Vue.use(Toast);
Vue.use(Col);
Vue.use(Row);
Vue.use(Button);
Vue.use(Popup);

import { VUE_GAME_ASSETS_URL } from "@utils";
import { getUserInfo } from "@api/user";
import { game10_config, game10_start, game10_end } from "@api/game";

// import { playGame } from "@utils/games/game10_tyt";
import Phaser from "phaser";
export default {
  name: "Game10_ddp",
  data() {
    return {
      user_id: 0,
      user_score: 0,
      log_id: 0,
      showStart: true,
      showEnd: false,
      showEndTip: false,
      price: 1000,
      gameConf: {
        coinAdd: 5,
      },
      play_times_today:10,
      play_times_max:10,
      score: 0,
      step: 0,
    };
  },
  mounted: function () {
    vm = this;
    let that = this;
    getUserInfo().then((res) => {
      that.user_id = res.data.uid;
      game10_config({ user_id: that.user_id }).then((res) => {
        console.log(res);
        that.user_score = parseFloat(res.data.user_score);
        that.price = res.data.price;
        that.gameConf = res.data.gameConf;
        that.play_times_today = res.data.play_times_today;
        gameOptions.columns = res.data.gameConf.columns;
        onload();
      });
    });
  },
  methods: {
    gameStart() {
      let that = this;
      game10_start({ user_id: that.user_id })
        .then((res) => {
          console.log(res);
          that.user_score -= that.price;
          that.showStart = false;
          that.showEnd = false;
          that.score = 0;
          that.log_id = res.data;
          that.play_times_today++;
          tileGroup.setVelocityY(-gameOptions.tileSpeed);
        })
        .catch((err) => {
          Toast.fail(err.msg);
        });

      // game.scene.start("PlayGame");
    },
    gameEnd() {
      let that = this;
      that.showEndTip = true;
      setTimeout(function () {
        that.showEnd = true;
        that.showEndTip = false;
        game10_end({
          user_id: that.user_id,
          score: that.score,
          log_id: that.log_id,
        }).then(() => {});
      }, 1000);
    },
    addScore() {
      this.step++;

      gameOptions.tileSpeed += 1;
      tileGroup.setVelocityY(-gameOptions.tileSpeed);

      this.score += this.gameConf.coinAdd;
    },
    quit() {
      this.$router.push({ path: "/user" });
    },
  },
  beforeDestroy: function () {
    if (game) {
      game.destroy();
    }
    let canvas = document.getElementsByTagName("canvas");
    if (canvas[0]) canvas[0].remove();
  },
};
let vm;
let game, tileGroup;
let gameOptions = {
  // 列数
  columns: 5,
  // 行数
  rows: 20,
  // 每秒移动像素
  tileSpeed: 200,
};
let bgm;
let onload = function () {
  let gameConfig = {
    type: Phaser.AUTO,
    scale: {
      // mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: 750,
      height: 1334,
    },
    transparent: true,
    parent: "game",
    physics: {
      default: "arcade",
    },
    scene: playGame,
  };
  game = new Phaser.Game(gameConfig);
  window.focus();
  resize();
  window.addEventListener("resize", resize, false);
};
class playGame extends Phaser.Scene {
  constructor() {
    super("PlayGame");
  }
  preload() {
    this.load.setBaseURL(VUE_GAME_ASSETS_URL);
    this.load.spritesheet("tiles", "/games/game10/tiles.png", {
      frameWidth: 100,
      frameHeight: 100,
    });
      this.load.audio("bg", "/games/game10/bg.mp3");
      this.load.audio("die", "/games/game10/die.mp3");
      this.load.audio("down", "/games/game10/down.mp3");
  }
  create() {
    if(!bgm){
      bgm=this.sound.add("bg");
      bgm.addMarker({
          name: 'loop',
          config: {
              loop: true,
              volume: 0.1
          }
      });
      bgm.play('loop');
    }
    // 创建物理引擎组
    tileGroup = this.physics.add.group();

    // 根据游戏宽度和栏目确定砖块大小
    this.tileSize = game.config.width / gameOptions.columns;

    // 添加砖块
    for (let i = 0; i < gameOptions.rows; i++) {
      // 构建一个与行数一样的数组
      let values = Phaser.Utils.Array.NumberArray(0, gameOptions.columns - 1);

      // 随机打乱数组
      Phaser.Utils.Array.Shuffle(values);

      // 保存中间列第一行的颜色
      if (i == 0) {
        var middleColor = values[Math.floor(gameOptions.columns / 2)];
      }

      // 一行一行的放置砖块
      for (let j = 0; j < gameOptions.columns; j++) {
        // add a tile. Tile frame is set according to "values" shuffled array
        let tile = tileGroup.create(
          j * this.tileSize,
          i * this.tileSize + (game.config.height / 4) * 3,
          "tiles",
          values[j]
        );

        // call adjustTile method to adjust tile origin and display size
        this.adjustTile(tile);
      }
    }

    // let's build once again an array with integers between 0 and gameOptions.columns - 1
    let values = Phaser.Utils.Array.NumberArray(0, gameOptions.columns - 1);

    // remove the item at "middlecolor" position because we don't want it to be randomly selected
    values.splice(middleColor, 1);

    // add the player to the game. Player color is picked amoung "values" array items, which does not contain anymore "middlecolor" value
    this.player = tileGroup.create(
      this.tileSize * Math.floor(gameOptions.columns / 2),
      (game.config.height / 4) * 3 - this.tileSize,
      "tiles",
      Phaser.Utils.Array.GetRandom(values)
    );

    // adjust player origin and display size
    this.adjustTile(this.player);

    // the score
    this.score = 0;

    // add score text
    this.scoreText = this.add.text(0, 0, "0", {
      fontFamily: "Arial Black",
      fontSize: this.tileSize / 3,
      color: "#ffffff",
    });

    // set a stroke to score text
    this.scoreText.setStroke("#000000", this.tileSize / 6);

    // method to adjust score position
    this.adjustScorePosition();

    // move entire tile group up by gameOptions.tileSpeed pixels / second
    // tileGroup.setVelocityY(-gameOptions.tileSpeed);

    // can the player move? Yes, at the moment
    this.canMove = true;

    // did we match any tile? No, at the moment
    this.matched = false;

    // wait for player input
    this.input.on("pointerdown", this.moveTile, this);
  }

  // method to set tile origin and display size
  adjustTile(sprite) {
    // set origin at the top left corner
    sprite.setOrigin(0);

    // set display width and height to "tileSize" pixels
    sprite.displayWidth = this.tileSize;
    sprite.displayHeight = this.tileSize;
  }

  // method to adjust score position
  adjustScorePosition() {
    // adjust score position according to its bounding box and player position
    this.scoreText.x =
      this.player.x + (this.tileSize - this.scoreText.getBounds().width) / 2;
    this.scoreText.y =
      this.player.y + (this.tileSize - this.scoreText.getBounds().height) / 2;
  }

  // method to move player tile
  moveTile(pointer) {
    // if we can move...
    if (this.canMove) {
      // determine column according to input coordinate and tile size
      let column = Math.floor(pointer.x / this.tileSize);

      // get the ditance from current player tile and destination
      let distance = Math.floor(
        Math.abs(column * this.tileSize - this.player.x) / this.tileSize
      );

      // did we actually move?
      if (distance > 0) {
        // we can't move anymore
        this.canMove = false;

        // tween the player to destination tile
        this.tweens.add({
          targets: [this.player],
          x: column * this.tileSize,
          duration: distance * 30,
          callbackScope: this,
          onComplete: function () {
            // at the end of the tween, check for tile match
            this.checkMatch();
          },
        });
      }
    }
  }

  // method to check tile matches
  checkMatch() {
    // get tile below player tile
    let tileBelow = this.physics.overlapRect(
      this.player.x + this.tileSize / 2,
      this.player.y + this.tileSize * 1.5,
      1,
      1
    );

    // "tileBelow" is an array so we have to compare the first - and only - item frame with player frame. Are the two frames the same?
    if (tileBelow[0].gameObject.frame.name == this.player.frame.name) {
      // we have a match
      this.matched = true;

      vm.addScore();
      this.sound.add("down").play();

      // check the whole row below player tile
      let rowBelow = this.physics.overlapRect(
        0,
        this.player.y + this.tileSize * 1.5,
        game.config.width,
        1
      );

      // tween down the player
      this.tweens.add({
        targets: [this.player],
        y: tileBelow[0].gameObject.y,
        duration: 100,
        callbackScope: this,
        onUpdate: function (tween, target) {
          // at each update, we have to adjust player position because tiles continue moving up
          this.player.y = Math.min(this.player.y, tileBelow[0].gameObject.y);
        },

        // at the end of the tween, we have to move the row at the bottom, to reuse sprites
        onComplete: function () {
          // increment score
          this.score++;

          // update score text
          this.scoreText.setText(this.score);

          // the good old array with all integers from zero to gameOptions.columns - 1
          let values = Phaser.Utils.Array.NumberArray(
            0,
            gameOptions.columns - 1
          );

          // let's shuffle the array
          Phaser.Utils.Array.Shuffle(values);

          // place all tiles below the lowest row
          for (let i = 0; i < gameOptions.columns; i++) {
            rowBelow[i].gameObject.setFrame(values[i]);
            rowBelow[i].gameObject.y += this.tileSize * gameOptions.rows;
          }

          // check for matches again, there could be a combo
          this.checkMatch();
        },
      });
    }

    // what to do when player moved but there isn't any match?
    else {
      // we can move again
      this.canMove = true;

      // is there a previous match? Did we come here from a previous match?
      if (this.matched) {
        // no more matches
        this.matched = false;

        // get the tile below the player
        let tileBelow = this.physics.overlapRect(
          this.player.x + this.tileSize / 2,
          this.player.y + this.tileSize * 1.5,
          1,
          1
        );

        // the good old array with all integers from zero to gameOptions.columns - 1
        let values = Phaser.Utils.Array.NumberArray(0, gameOptions.columns - 1);

        // remove the item at "frame" value of tile below the player pbecause we don't want it to be randomly selected
        values.splice(tileBelow[0].gameObject.frame.name, 1);

        // change player frame
        this.player.setFrame(Phaser.Utils.Array.GetRandom(values));
      }
    }
  }

  // method to be executed at each frame
  update() {
    // we need to adjust score position at each frame
    this.adjustScorePosition();

    // if the player touches the top of the screen...
    if (this.player.y < 0) {
      vm.gameEnd();
      this.sound.add("die").play();
      // gmae over man, restart the game
      this.scene.start("PlayGame");
    }
  }
}

function resize() {
  let canvas = document.querySelector("canvas");
  let windowWidth = window.innerWidth;
  let windowHeight = window.innerHeight;
  let windowRatio = windowWidth / windowHeight;
  let gameRatio = game.config.width / game.config.height;
  if (windowRatio < gameRatio) {
    canvas.style.width = windowWidth + "px";
    canvas.style.height = windowWidth / gameRatio + "px";
  } else {
    canvas.style.width = windowHeight * gameRatio + "px";
    canvas.style.height = windowHeight + "px";
  }
}
</script>

